import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type HAFieldProps = {
  width: string
}

export const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${theme.spacing.sm};

  justify-content: flex-end;
`

export const HeaderField = styled.div<HAFieldProps>`
  display: flex;
  align-items: flex-end;
  width: ${({ width }) => width};
`

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap-reverse;
  gap: ${theme.spacing.xm};
  justify-content: space-between;
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.lg}px) {
    width: 100%;
  }
`

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
`

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
`
